export const columnsDataCheck = [
  {
    Header: "CHECKBOX",
    accessor: "check_all",
    id: "checkbox",
    disableSortBy: true,
  },
  {
    Header: "NAVN",
    accessor: (row) => row.chip_id,
    id: "chipId",
  },
  {
    Header: "AVDELING",
    accessor: (row) => row.department.name,
    id: "departmentName",
  },
  {
    Header: "ONLINE",
    accessor: (row) => row.is_connected,
    id: "is_connected",
  },
  {
    Header: "SIST SETT",
    accessor: (row) => row.last_position_gotten_at?.$date,
    id: "last_seen",
  },
];